import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const TOTAL_PER_CURRENCY_SCHEMA = Object.freeze({
  CURRENCY_CODE: '',
  TOTAL: 0,
});
const RECORD = generateSchema(TOTAL_PER_CURRENCY_SCHEMA);
const KEYS: any = generateKeys(TOTAL_PER_CURRENCY_SCHEMA);

export class TotalPerCurrency extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get currencyCode(): string {
    return this.get(KEYS.CURRENCY_CODE);
  }

  get total(): number {
    return this.get(KEYS.TOTAL);
  }
}
